import { useState, useEffect } from "react";
import SideMenu from "../../features/sideMenu/SideMenu";
import Map from "../../ui/map/Map";
import { buscarTrabajosPorCriterios } from "../functions/Projects";
import { itemsProjects } from "../../constants/projects";
import MarkerProyectoConcluido from "../../assets/img/svg/projects/torre-activo.svg";
import MarkerProyectoEnProceso from "../../assets/img/svg/projects/torre-en-proceso.svg";
import MarkerProyectoInactivo from "../../assets/img/svg/projects/torre-inactivo.svg";
import MarkerProyectoSinEstatus from "../../assets/img/svg/projects/torre-sin-estatus.svg";
import CountProyectoConcluido from "../../assets/img/svg/projects/countProyectoConcluido.svg";
import CountProyectoEnProceso from "../../assets/img/svg/projects/countProyectoenEjecucion.svg";
import CountProyectoInactivo from "../../assets/img/svg/projects/countProyectoInactivo.svg";
import "./MapProjectsPage.responsive.css";
import CustomButton from "../../ui/button/Button";
import Buscar from "../../assets/img/svg/buscar.svg";
import { defaultCriteriosWithId } from "../../constants/projects";
import ProjectFilterModal from "../../features/projectFilterModal/ProjectFilterModal";
import LoaderDialog from "../../ui/loader/Loader";
import FilterChips from "./FilterChips";

const MapProjectsPage = ({
  API_URL,
  clients,
  permisionarios,
  projects,
  companies,
  states,
}) => {
  const [criterios, setCriterios] = useState(defaultCriteriosWithId);
  const [markers, setMarkers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [filteredMarkers, setFilteredMarkers] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const [counts, setCounts] = useState({
    activo: 0,
    proceso: 0,
    inactivo: 0,
  });

  const opcionesEstadisticas = [
    { value: null, label: "Todos" },
    { value: "Concluido", label: "Proyectos concluidos" },
    { value: "En proceso", label: "Proyectos en ejecución" },
    { value: "Inactivo", label: "Proyectos inactivos" },
  ];

  const handleStatusCardClick = (status) => {
    if (selectedStatus && selectedStatus.value === status) {
      setSelectedStatus({ value: null, label: "Todos" });
    } else {
      setSelectedStatus(
        opcionesEstadisticas.find((opt) => opt.value === status),
      );
    }
  };

  useEffect(() => {
    if (!selectedStatus || !selectedStatus.value) {
      setFilteredMarkers(markers);
      return;
    }
    setFilteredMarkers(
      markers.filter((marker) => {
        if (selectedStatus.value === "Concluido") {
          return marker.icon.includes("torre-activo");
        } else if (selectedStatus.value === "En proceso") {
          return marker.icon.includes("torre-en-proceso");
        } else if (selectedStatus.value === "Inactivo") {
          return marker.icon.includes("torre-inactivo");
        }
        return true;
      }),
    );
  }, [selectedStatus, markers]);

  useEffect(() => {
    setShowLoader(true);
    const fetchData = async () => {
      buscarTrabajosPorCriterios(
        API_URL,
        criterios,
        (resultados) => {
          const mappedMarkers = resultados.map((item) => ({
            lat: item.latitude,
            lng: item.longitude,
            icon:
              item?.estatus?.nombre === "Concluido"
                ? MarkerProyectoConcluido
                : item?.estatus?.nombre === "En proceso"
                  ? MarkerProyectoEnProceso
                  : item?.estatus?.nombre === "Inactivo"
                    ? MarkerProyectoInactivo
                    : MarkerProyectoSinEstatus,
            info: {
              esProyecto: true,
              status: item?.estatus?.nombre,
              nombre: item?.nombre,
              permisionario: item?.permisionario?.razonSocial,
              cliente: item?.cliente?.razonSocial,
              rpu: item?.rpu,
              proyecto: item?.proyecto?.nombre,
              direccion: item?.direccion,
            },
          }));

          const newCounts = resultados.reduce(
            (acc, item) => {
              const status = item?.estatus?.nombre;

              if (status === "Concluido") acc.activo += 1;
              else if (status === "En proceso") acc.proceso += 1;
              else if (status === "Inactivo") acc.inactivo += 1;

              return acc;
            },
            { activo: 0, proceso: 0, inactivo: 0 },
          );

          setMarkers(mappedMarkers);
          setCounts(newCounts);
          setSelectedStatus({ value: null, label: "Todos" });
          setShowLoader(false);
        },
        (errorMsg) => {
          console.log(errorMsg);
          setShowLoader(false);
        },
      );
    };

    fetchData();
  }, [criterios]);

  return (
    <div className="mpp-container" style={{ display: "flex", width: "100%" }}>
      <LoaderDialog open={showLoader} />

      <div className="mpp-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsProjects} />
      </div>
      <div
        className="mpp-content"
        style={{ flex: 1, padding: "10px", width: "100%" }}
      >
        <div
          className="mpp-controls"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "10px",
          }}
        >
          <h1 className="map-title" style={{ margin: 0 }}>
            Mapa de proyectos ({markers.length})
          </h1>
          <div
            className="mpp-selectWrap"
            style={{ display: "flex", gap: "8px", alignItems: "center" }}
          >
            <CustomButton
              background={"#FFFFFF"}
              width={"160px"}
              height={"38px"}
              fontSize={"14px"}
              color={"#223D51"}
              text={"Filtros Avanzados"}
              fontWeight={700}
              fontStyle={"normal"}
              border={"0.5px solid #C3C3C3"}
              icon={true}
              src={Buscar}
              iconW={"12px"}
              iconM={"5px"}
              onClick={() => setShowModal(true)}
            />
            <FilterChips
              criterios={criterios}
              onChange={setCriterios}
              projects={projects}
              permisionarios={permisionarios}
              states={states}
              clients={clients}
              companies={companies}
              height={"31px"}
            />
          </div>

          {/* Conteos */}
          <div className="mp-counters">
            <div
              className={`map-status-status map-status-status-select d-flex ${
                selectedStatus?.value === "Concluido"
                  ? "selected-map-filter"
                  : ""
              }`}
              onClick={() => handleStatusCardClick("Concluido")}
            >
              <img src={CountProyectoConcluido} alt="Activo" />
              <div className="map-status-status-text">
                <p className="status-label">Concluidos</p>
                <p className="status-value">{counts.activo}</p>
              </div>
            </div>

            <div
              className={`map-status-status map-status-status-select d-flex ${
                selectedStatus?.value === "En proceso"
                  ? "selected-map-filter"
                  : ""
              }`}
              onClick={() => handleStatusCardClick("En proceso")}
            >
              <img src={CountProyectoEnProceso} alt="En proceso" />
              <div className="map-status-status-text">
                <p className="status-label">En ejecución</p>
                <p className="status-value">{counts.proceso}</p>
              </div>
            </div>

            <div
              className={`map-status-status map-status-status-select d-flex ${
                selectedStatus?.value === "Inactivo"
                  ? "selected-map-filter"
                  : ""
              }`}
              onClick={() => handleStatusCardClick("Inactivo")}
            >
              <img src={CountProyectoInactivo} alt="Inactivo" />
              <div className="map-status-status-text">
                <p className="status-label">Inactivos</p>
                <p className="status-value">{counts.inactivo}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="mpp-mapWrap">
          <Map markers={filteredMarkers} />
        </div>
      </div>
      <ProjectFilterModal
        states={states}
        companies={companies}
        projects={projects}
        clients={clients}
        permisionarios={permisionarios}
        handleCloseModal={() => setShowModal(false)}
        showModal={showModal}
        criterios={criterios}
        setCriterios={setCriterios}
      />
    </div>
  );
};

export default MapProjectsPage;
